export enum SeriesTab {
  LEARN = 'Learn',
  GROUP_CHAT = 'Group Chat',
  ASSESSMENTS = 'Assessments',
  PARTICIPANTS = 'Participants',
  FEEDBACK = 'Feedback',
  GIVE_FEEDBACK = 'Give Feedback',
}
